import request from "@/utils/request.util";
import { Capacitor } from "@capacitor/core";
import { APP_BASE_API_URL } from "@/config/app.config";

const PROVIDER = "hungryhub";
const MINOR_VERSION = "3";

function platform() {
  try {
    return Capacitor.getPlatform();
  } catch (_) {
    return "web";
  }
}

function dashboardBaseUrl() {
  try {
    const origin = new URL(APP_BASE_API_URL).origin;
    return `${origin}/api/`;
  } catch (_) {
    return APP_BASE_API_URL;
  }
}

export function subscribeDevice(token) {
  return request.post(`${dashboardBaseUrl()}dashboard/staff/subscribe`, {
    provider: PROVIDER,
    minor_version: MINOR_VERSION,
    firebase_instance_id: token,
    platform: platform(),
  });
}

export function unsubscribeDevice(token) {
  return request.post(`${dashboardBaseUrl()}dashboard/staff/unsubscribe`, {
    provider: PROVIDER,
    minor_version: MINOR_VERSION,
    firebase_instance_id: token,
    platform: platform(),
  });
}
